/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<template>
	<table class="detailed-list">
		<tr class="tr-td-control">
			<c-viewHeaderParam
				ref="v_basic"
				:r_messages = "r_messages" 
				:r_settings = "r_settings" 
				:r_class_code="r_class_code"
				:r_class_name="r_info.company_name"
				:r_code="r_code"
				:r_code2="r_code2"
				:r_info="m_info" 
				:r_header="m_info" 
				:r_code_name="r_code_name" 
				:r_code2_name="r_code2_name"
				:r_is_new="r_is_new">
			</c-viewHeaderParam>
		</tr>
	</table>
</template>
<script>
	/**
	 * ユーザーの管理画面 - 詳細画面表示コンポーネント
	 * @vuedoc
	 * @exports js/parts/user/viewParam
	 */
	 export default {
		mixins: [
			require('js/common/viewParamBase.mixin.vue'),
		],
		data:function (){
			return{
			};
		},
		created: function(){
		},
		watch:{
			//! 空き番号検索による変更
			r_code:function(val){
				this.m_strCode = this.r_code;
			},
		},
		/**
		 * @prop {Object} disp_pass_placeholder - パスワードのプレースホルダー
		 * @instance
		 **/
		computed: {
		},
		// ----------------------------------------------------------------------------
		methods: { 
			/**
			 * データ変更フラグの更新
			 * 
			 * @function updateChangeDataFlag
			 */
			updateChangeDataFlag: function(){
				this.$refs.v_basic.updateChangeDataFlag();
			},
			/**
			 * 変更フラグcheck <br>
			 * ******* 内部処理 *******<br>
			 * 変更フラグを取得する。 <br>
			 *
			 * @function checkUpdate
			 * @returns 変更有無
			 */
			checkUpdate:function(){
				if ( 
					this.$refs.v_basic.checkUpdate() 
				) {
					return true;
				}
				return false;
			},
			/**
			 * バリデーション
			 * 
			 * @returns バリデーション結果
			 */
			validate:function(){
				var is = true;
				is = this.$refs.v_basic.validate()?is:false;
				
				return is;
			},
			/**
			 * メッセージのクリア
			 */
			clearMessage:function(){
			},
			/**
			 * 更新データの取得
			 * 
			 * @function getData
			 * 
			 * @returns 更新データ 
			 */
			getData : function(){
				let baseData = this.$refs.v_basic.getData();

				return baseData;
			},
		},
		/**
		 * ファイル内で使用しているコンポーネント <br>
		 * cはグローバルコンポーネント(宣言は親のjsファイルで行っている)<br>
		 * myはローカルコンポーネント <br>
		 * @prop {component} c-edititemcode - 詳細画面呼び出しコードコンポーネント
		 * @prop {component} c-inputname - 文字入力コンポーネント
		 * @prop {component} c-btnchoicimage - イメージ選択ボタン
		 * @prop {component} c-labelnum - 数値表示
		 * @instance
		 **/
		components: {
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts/user/header/viewParam.vue